import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { chrysoula_data, Heidari_data } from '../../assets'

const Chrysoula = () => {
  return (
    <>
    <PanelMemberTemplate {...chrysoula_data}/>
    </>
  )
}

export default Chrysoula